import axios, { AxiosError } from "axios";
import { config } from "../../../../config";
import { calculateDelay, RetryConfig, shouldRetry } from "./axios.config";

// Reuse the existing retry logic and interceptors
const createApiClient = (baseURL: string) => {
  const client = axios.create({
    baseURL,
    headers: {
      "Content-Type": "application/json",
      "User-Agent": "YourAppName/1.0", // Replace with your app name
    },
  });

  // Response interceptor for retries
  client.interceptors.response.use(
    (response) => response,
    async (error: AxiosError) => {
      const reqConfig = error.config as RetryConfig;
      if (!reqConfig) {
        return Promise.reject(error);
      }
      if (typeof reqConfig.retryCount === "undefined") {
        reqConfig.retryCount = 0;
      }

      const statusCode = error.response?.status;
      console.log(`API call failed. Attempt ${reqConfig.retryCount + 1}`, {
        url: reqConfig.url,
        error: error.message,
        statusCode,
      });

      if (
        shouldRetry(error) &&
        reqConfig.retryCount < config.lambda.retry.maxRetries
      ) {
        reqConfig.retryCount += 1;
        const delay = calculateDelay(reqConfig.retryCount);
        console.log(`Retrying after ${delay}ms... Status code: ${statusCode}`);
        await new Promise((resolve) => setTimeout(resolve, delay));
        return client(reqConfig);
      }

      return Promise.reject(error);
    }
  );

  return client;
};

// Create API clients for Nominatim and Photon
export const nominatimApiClient = createApiClient(
  config.mapsAPI.nominatim.baseUrl
);
export const photonApiClient = createApiClient(config.mapsAPI.photon.baseUrl);
